module.exports = __webpack_public_path__ + "media/img/frontend_application/nav-logo-white-907d5fab119bd7a1f54beac96cef6fdb.png";